<template>
  <div style="height: 100%">
    <iframe
      name="videoFrame"
      src="static/videoApi/index.html"
      id="lyvideo"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    open(v) {
      window["videoFrame"].window.play(v);
    },
    pause(v) {
      window["videoFrame"].window.pause(v);
    },
  },
  mounted() {
    setTimeout(() => {
      //this.play()
    }, 2000);
  },
};
</script>
<style>
#lyvideo {
  width: 100%;
  height: calc(100% - 10px);
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/video/video.vue